<template lang="pug">
  .container
    .header-wrapper
      el-select(v-model="currency" @change="changeCurrency" class="currency")
        el-option(label="币本位" value="USD")
        el-option(label="U本位" value="USDT")
      ul(class="head-box")
        li(v-for="c in cylces"
          :key="c.name" 
          :class="c.selected ? 'cylces active-cycle' : 'cylces'"
          @click="changeCycle(c)") {{c.name}}
    .main
      .left
        contractList(currency="USDT" :cycle="selectedCycle.value" @change="handleQuoteChange")
      .right
        .til
          .til-left {{quote && quote.alias}}
          .til-right
            el-button(type="primary" plain @click="handleLeverage") {{`杠杆倍数 ${leverage}X`}}
        .tabs
          el-tabs(v-model="side" @tab-click="handleTab" stretch)
            el-tab-pane(label="开仓" name="open")
              el-form(ref="form" :model="form" :rules="rules" class="form" label-width="120px")
                el-form-item(label="委托类型" prop="orderType")
                  el-select(v-model="form.orderType" placeholder="请选择委托类型")
                    el-option(label="限价委托" :value="0")
                    el-option(label="市价委托" :value="1")
                    el-option(label="止盈止损" :value="2")
                el-form-item(v-if="form.orderType===0" label="价格" prop="price")
                  el-input(v-model="form.price" :disabled="disablePriceIpt")
                    el-button(slot="append" @click="setMatchPrice") 对手价
                el-form-item(label="百分比" prop="sizeRatio")
                  el-slider(v-model="form.sizeRatio" show-input :step="0.1")
                div(v-if="form.orderType===2")
                  el-form-item(label="触发价格" prop="triggerPrice")
                    el-input(v-model="form.triggerPrice")
                  el-form-item(label="委托类型" prop="algoType")
                    el-select(v-model="form.algoType")
                      el-option(label="限价委托" :value="1")
                      el-option(label="市价委托" :value="2")  
                  el-form-item(v-if="form.algoType===1" label="委托价格" prop="algoPrice")
                    el-input(v-model="form.algoPrice")
                el-form-item(class="btn-wrapper")
                  div
                    el-button(type="success" @click="submit(1)" size="medium") 买入开多
                    el-button(type="danger" @click="submit(2)" size="medium") 卖出开空
            el-tab-pane(label="平仓" name="close")
              el-form(ref="form" :model="form" :rules="rules" class="form" label-width="120px")
                el-form-item(label="委托类型" prop="orderType")
                  el-select(v-model="form.orderType")
                    el-option(label="限价委托" :value="0")
                    el-option(label="市价委托" :value="1")
                    el-option(label="止盈止损" :value="2")
                el-form-item(v-if="form.orderType===0" label="价格" prop="price")
                  el-input(v-model="form.price" :disabled="disablePriceIpt")
                    el-button(slot="append" @click="setMatchPrice") 对手价
                el-form-item(label="百分比" prop="sizeRatio")
                  el-slider(v-model="form.sizeRatio" show-input :step="0.1")
                div(v-if="form.orderType===2")
                  el-form-item(label="触发价格" prop="triggerPrice")
                    el-input(v-model="form.triggerPrice")
                  el-form-item(label="委托类型" prop="algoType")
                    el-select(v-model="form.algoType")
                      el-option(label="限价委托" :value="1")
                      el-option(label="市价委托" :value="2")  
                  el-form-item(v-if="form.algoType===1" label="委托价格" prop="algoPrice")
                    el-input(v-model="form.algoPrice")
                el-form-item(class="btn-wrapper")
                  div
                    el-button(type="success" @click="submit(3)" size="medium") 卖出平多
                    el-button(type="danger" @click="submit(4)" size="medium") 买入平空
        .cancel
          el-button(type="primary" @click="cancelAllOrders") 全部撤单
    leverage-dialog(ref="leverageDialog" @change="setLeverage")
</template>

<script>
import contractList from 'components/ContractList';
import leverageDialog from 'components/LeverageDialog';
import { placeOrder, cancelAll } from 'api/futures';
import { getLeverage } from 'api/futures';

export default {
  components: {
    contractList,
    leverageDialog,
  },
  data() {
    return {
      currency: 'USDT',
      cylces: [
        { name: '当周', desc: 'weekly', value: '1', selected: true },
        { name: '次周', desc: 'biweekly', value: '2', selected: false },
        { name: '当季', desc: 'quarterly', value: '3', selected: false },
        { name: '次季', desc: 'biquarterly', value: '4', selected: false },
      ],
      side: 'open', // open - close
      quote: undefined,
      isMatchPrice: false,
      disablePriceIpt: false,
      form: {
        orderType: 0,
        price: '',
        sizeRatio: 0,
        triggerPrice: '',
        algoType: '',
        algoPrice: '',
      },
      leverage: 0,
      rules: {},
    };
  },
  computed: {
    selectedCycle() {
      return this.cylces.find((qt) => qt.selected);
    },
  },
  watch: {
    $route(to) {
      const contract = to.params.cycle;
      const desc = contract.split('-')[1];
      this.cylces.forEach((c) => {
        if (c.desc === desc) {
          c.selected = true;
        } else {
          c.selected = false;
        }
      });
    },
  },
  created() {},
  mounted() {},
  methods: {
    queryLeverage() {
      getLeverage({
        currency: this.quote.currency,
      })
        .then((res) => {
          if (res.code === 0) {
            this.leverage = Number(res.data.leverage);
          } else {
            this.$message.error(res.msg || '获取杠杆倍数失败');
          }
        })
        .catch((ex) => {
          this.$message.error(ex.message || '获取杠杆倍数发生错误');
        });
    },
    setLeverage(leverage) {
      this.leverage = leverage;
    },
    changeCurrency() {
      if (this.currency === 'USD') {
        this.$router.replace({ path: `/futures-usd/btc-weekly` });
      } else {
        this.$router.replace({ path: `/futures-usdt/btc-weekly` });
      }
    },
    changeCycle(c) {
      if (c.selected) return;
      switch (c.desc) {
        case 'weekly':
          this.$router.replace({ path: `/futures-usdt/btc-weekly` });
          break;
        case 'biweekly':
          this.$router.replace({ path: `/futures-usdt/btc-biweekly` });
          break;
        case 'quarterly':
          this.$router.replace({ path: `/futures-usdt/btc-quarterly` });
          break;
        case 'biquarterly':
          this.$router.replace({ path: `/futures-usdt/btc-biquarterly` });
          break;
        default:
          this.$message.error('切换合约周期出错');
          throw new Error('切换合约周期出错');
      }
    },
    handleQuoteChange(quote) {
      this.quote = quote;
      this.queryLeverage();
    },
    handleLeverage() {
      this.$refs.leverageDialog.open(this.quote, this.leverage);
    },
    handleTab(side) {
      if (this.side === side.name) return;
      this.side = side.name;
      this.$refs['form'].resetFields();
    },
    setMatchPrice() {
      this.isMatchPrice = !this.isMatchPrice;
      if (this.isMatchPrice) {
        this.form.price = '';
        this.disablePriceIpt = true;
      } else {
        this.disablePriceIpt = false;
      }
    },
    async submit(type) {
      const res = await placeOrder({
        instrumentId: this.quote.instrumentId,
        alias: this.quote.alias,
        currency: this.quote.currency,
        type,
        matchPrice: this.isMatchPrice ? 1 : 0,
        ...this.form,
        sizeRatio: this.form.sizeRatio / 100,
      }).catch((err) => this.$message.error(err.msg || '下单异常'));
      if (res.code === 0) {
        this.$message.success('下单成功');
      } else {
        this.$message.error(() => this.$message.error(res.msg || '下单失败'));
      }
    },
    async cancelAllOrders() {
      const res = await cancelAll({
        instrumentId: this.quote.instrumentId,
        alias: this.quote.alias,
      }).catch((err) => this.$$message.error(err.msg || '撤单发生错误'));
      if (res.code === 0) {
        this.$message.success('撤单成功');
      } else {
        this.$message.error(res.msg || '撤单失败');
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import '../../styles/consts.less';

.container {
  width: 100%;
  height: 40px;
  line-height: 40px;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.05);
  color: rgba(0, 0, 0, 0.65);
  .header-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 500px;
    margin: 0 auto;
    .head-box {
      display: inline-block;
      position: relative;
      // width: 1180px;
      // margin: 0 auto;
      padding: 0;
      text-align: center;
      .cylces {
        font-size: 14px;
        display: inline-block;
        margin-right: 24px;
        padding: 0 8px;
        cursor: pointer;
        // text-align: center;
      }
      .active-cycle {
        box-shadow: inset 0 -2px 0 0 @themeColor;
        color: @themeColor;
      }
    }
  }
}
.main {
  position: relative;
  display: flex;
  width: 1180px;
  margin: 0 auto;
  padding-top: 24px;
  .left {
    display: block;
    width: 200px;
    margin-right: 40px;
  }
  .right {
    flex: 1;
    .til {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 30px;
      font-weight: 400;
      height: 45px;
      line-height: 45px;
      margin-bottom: 8px;
      .til-left {
      }
      .til-right {
      }
    }
    .assets {
      font-size: 12px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      height: 36px;
      padding: 6px 18px;
      border-radius: 8px;
      background-color: rgba(0, 0, 0, 0.03);
      color: rgba(0, 0, 0, 0.45);
      a {
        color: #3075ee;
        text-decoration: none;
        cursor: pointer;
      }
    }
    .form {
      margin: 48px auto;
      width: 600px;
      .btn-wrapper {
        width: 100%;
        margin-top: 48px;
        .el-button {
          width: 45%;
          padding: 12px;
        }
      }
    }
  }
  .cancel {
    text-align: right;
  }
}
</style>
